export default {
      id: "icon-circled-minus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-circled-minus",
      toString: function () {
        return this.url;
      }
    }